import { ICollection } from 'Interfaces/Product';

export const constants = Object.freeze({
	SPACING: 1.5,
	BANNER_LOG: 125,
	PAGE_SIZE: 8
});

export const collections: ICollection[] = [
	{
		id: 1,
		key: 'imagine',
		name: 'Imagine'
	},
	{
		id: 2,
		key: 'lasyDays',
		name: 'Last days'
	},
	{
		id: 3,
		key: '3dIcPets',
		name: '3D IC Pets'
	},
	{
		id: 4,
		key: 'gameItems',
		name: 'Game Items'
	},
	{
		id: 5,
		key: '3dTemplates',
		name: '3D Templates'
	},
	{
		id: 6,
		key: 'davidKozma',
		name: 'David Kozma'
	}
];

export const sort = [
	{
		id: 1,
		key: 'priceAsc',
		name: 'Price: Low to High'
	},
	{
		id: 2,
		key: 'priceDesc',
		name: 'Price: High to Low'
	}
];
